import React from "react";
import type { ChangeEvent } from "react";
import type { LucideIcon } from "lucide-react";
import styles from "./InputIcon.module.css";

interface InputIconProps {
  icon: LucideIcon;
  placeholder: string;
  type?: string;
  value?: string;
  small?: boolean;
  id?: string;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyUp?: (value: string) => void;
  rightIcon?: LucideIcon;
  onRightIconClick?: () => void;
}

const InputIcon = React.forwardRef<HTMLInputElement, InputIconProps>(
  (
    {
      icon: Icon,
      type = "text",
      placeholder,
      value,
      small,
      id,
      name,
      onChange,
      onBlur,
      onKeyUp,
      rightIcon: RightIcon,
      onRightIconClick,
    },
    ref,
  ) => {
    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
      const currentValue = event.currentTarget.value;
      if (onKeyUp && currentValue.length >= 3) {
        onKeyUp(currentValue);
      }
    };

    return (
      <div className={`${styles.inputContainer} ${small ? styles.small : ""}`}>
        <input
          ref={ref}
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyUp={handleKeyUp}
          className={`${styles.inputField} ${RightIcon ? styles.inputFieldWithRight : ""}`}
        />
        <span className={styles.iconContainer}>
          <Icon className={styles.icon} />
        </span>
        {RightIcon && (
          <button
            type="button"
            className={styles.rightIconButton}
            onClick={onRightIconClick}
            tabIndex={-1}
          >
            <RightIcon className={styles.icon} />
          </button>
        )}
      </div>
    );
  },
);

InputIcon.displayName = "InputIcon";

export default InputIcon;
